export const SDK_NAME = 'prodantix-js';
export const SDK_VERSION = '0.7.0';
